<template>
	<div class="home_contain">
		<div class="service" @click="goService()">
			<img class="service_img" :src="require('../assets/img/icon/icon_kefu.png')" alt="">
		</div>
		<!-- 头部样式 -->
		<div class="home_header" :style="{ 'margin-bottom': marHeight }">
			<div class="pd-19 box-s home_header_main">
				<img class="home_header_bg" src="../assets/img/bg/home_bg_1.png" alt="">
				<div class="flexs mb-10 home_header_top fw-500">
					<div class=" fz-14 c0 home_header_name ls-1">{{$store.state.className}}</div>
					<div class="fz-12 c1 flexs flex-center header-plan ml-7" @click="change_plan">
						调整计划 <span class=" iconfont icon-youjiantou c2 fz-6 ml-5"></span></div>
				</div>
				<div class="flexs home_header_bottom fz-18 fw-600 c1">
					<span class="mr-10 ls-1">距离考试还有</span>
					<div class="he-time">{{$store.state.day1}}</div>
					<div class="he-time mlr-4">{{$store.state.day2}}</div>
					<div class="he-time">{{$store.state.day3}}</div>
					<span class="ml-4">天</span>
				</div>
				
			</div>
		</div>
		<!-- 轮播图 -->
		<div class="ptrl-22-16 mb-22">
			<swipeItem v-if="swipeList.length > 0" :swipeList="swipeList" :height="height" ></swipeItem>
		</div>
		<!-- 首页选项 -->
		<div class="home_option">
			<div class="flex-wrap home_option_div">
				<div class="every_option list_every ptl-8 box-s" v-for="(item, index) in optionList" :key="index" @click="jumpOption(item.url, item.power)">
					<div class="fz-14 fw-500 c1 mb-8">{{item.txt}}</div>
					<div class="fz-10 c2">{{item.sub_txt}}</div>
					<div class="every_option_img_con">
						<img class="every_option_img" :src="require('../assets/img/icon/home_icon_'+ (index + 1) +'.png')"
						alt="">
					</div>
				</div>
			</div>
		</div>
		<!-- 答题数据 -->
		<div class="answer_data">
			<div class="flexs flex-jus title_header">
				<div class="flexs">
					<div class="title_line"></div>
					<div class="fw-600 fz-18 c1 ml-8">答题数据</div>
				</div>
				<div class="flexs">
				</div>
			</div>

			<div class="answer_data_main list_every flexs text-center">
				<img class="answer_data_img" src="../assets/img/bg/home_answer_bg.png" alt="">

				<div class="flex1">
					<div class="answer_data_txt fz-14 c1">答题数量</div>
					<div class="data_num_sty c0">{{data.all_answer_amount?data.all_answer_amount:0}}</div>
				</div>
				<div class="answer_data_middle_line"></div>
				<div class="flex1">
					<div class="answer_data_txt fz-14 c1">正确率</div>
					<div class="data_num_sty c0">{{data.right_percent?data.right_percent:0}}%</div>
				</div>
			</div>
		</div>

		<div class="news_contain" v-if="!mer_id">
			<div class="flexs flex-jus title_header">
				<div class="flexs">
					<div class="title_line"></div>
					<div class="fw-600 fz-18 c1 ml-8">更新资讯</div>
				</div>
				<div class="flexs" @click="getZy">
					<div class="fz-12 c0 fw-500">更多资讯</div>
					<img class="news_right_icon" src="../assets/img/icon/blue_right_arrow.png" alt="">
				</div>
			</div>

			<div class="mlr-16 list_every">
				<List :list="list"></List>
			</div>
		</div>
		<div class="pup_con" v-if="showpup">
			<div class="pup_img_con" @click="clickJump">
        <img class="pup_img" :src="img" alt="">
				<div class="wh_30 cha" @click.stop="chahao">
					<img class="wh_30" src="../assets/img/icon/cicle_cha.png" alt="">
				</div>
			</div>
			
		</div>
		<div class="beian">
			冀ICP备18039353号-8
			冀公网安备13010202003728号
		</div>
		<!-- <van-popup v-model="showPicker" :height="4" round position="bottom">
			<van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
		</van-popup> -->
		<!-- 老师二维码遮罩层 -->
		<van-overlay :show="showService" @click="showService = false" v-if="showService">
			<div class=" w315 ps-45 b-radius-6 ptb-20 box-s bg_f text-center" @click.stop style="z-index:999999999;">
				<div class="fz-15 fw-500 c1">微信扫描二维码添加老师进行咨询</div>
				<img class="wh_126 mtb-31-ao" :src="userinfo.kf_img">
				<div class="wh_240_40 b-radius-6 c7 bg_49 fz-13 fw-500 m0-auto">长按图片保存到本地</div>
				<div class="iconfont icon-chahao icon" @click="showService = false"></div>
			</div>
		</van-overlay>
	</div>
</template>
<script>

	import { getAdvertising, informationType, informationList, userLoginLog, indexMemberStatistic,getEnglishBookPlan } from '../api/api.js'
	import '@/assets/css/home.less';
	import swipeItem from '@/components/swipeItem'
	import { formatTime } from '@/utils/common.js'
  import { getCode } from '@/utils/wx'
	import List from '@/components/List.vue'
	import { userInfo } from '@/api/api.js'
	export default {
		components: {
			List,
			swipeItem
		},
		data() {
			return {
				showService:false,//客服二维码弹框
				membership: 0,
				userinfo:{},

				value: '',
				columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
				optionList: [{
						txt: '单词本',
						sub_txt: '每日背单词',
						url: '/wordbook',
            power: 1
					},
					{
						txt: '每日一练',
						sub_txt: '练习得积分',
						url: '/practicelist',
            power: 1
					},
					{
						txt: '考点刷题',
						sub_txt: '专项训练',
						//url: '/testquset',
						url: '/testplace',
            power: 1
					},
					{
						txt: '随机刷题',
						sub_txt: '随机测试',
						url: '/randomquest',
            power: 1
					},
					{
						txt: '答题闯关',
						sub_txt: '闯关历练',
						url: '/passquest',
            power: 1
					},
					{
						txt: '错题集',
						sub_txt: '错题与收藏',
						url: '/mywrong',
            power: 1
					},
					{
						txt: '历年真题',
						sub_txt: '真题试炼',
						url: '/historyquset',
            power: 1
					},
					{
						txt: '模拟考试',
						sub_txt: '模拟演习',
						url: '/imitatequest',
            power: 1
					},
					{
						txt: '模考大赛',
						sub_txt: '万人大比拼',
						url: '/mideltest',
            power: 1
					}
				],
				list: [],
				swipeList: [],
				iid: 0,
				moredata: [],
				data: {},
				day1: 0,
				day2: 0,
				day3: 0,
				img: '',
				advertising_link: '',
				showpup: false,
				power: [],
				height: '',
				marHeight: '',
				mer_id: 0,
			};
		},
		created() {
			if(this.$route.query.mer_id) this.mer_id = this.$route.query.mer_id
			const searchParams = new URLSearchParams(window.location.search)
    		const urlCode = searchParams.get('code')
			if(urlCode){
        	getCode().then(()=>{
				console.log('首页getCode','getCode')
          		this.getUserLog()
					this.initIndexData()
					this.initData()
					this.initFormatData()
				}).catch(()=>{})
			} else {
        	this.getUserLog()
				this.initIndexData()
				this.initData()
				this.initFormatData()
			}
			
		},
		mounted(){
			
      this.height = (document.documentElement.clientWidth / 375) * 150 + 'px'
			// console.log(document.getElementByClass('home_header_main').offsetHeight,'ppp' )
			const height = document.getElementsByClassName("home_header_main")[0].offsetHeight
			this.marHeight = (height - 70) * (document.documentElement.clientWidth / 375) + 'px'
			//console.log(document.getElementsByClassName("home_header_main")[0].offsetHeight,'ppp' )
		},
		methods: {
			// async initDataUser(){
        	// 	const res = await userInfo()
			// 	if(res.code == 1000){
			// 		this.userinfo = res.data
			// 		this.membership = res.data.membership
			// 	}else {
			// 		 this.$toast(res.msg)
			// 	}
			// },
			change_plan(){
				//$router.push('/chooseexam')
				this.$dialog.alert({
					message: '请联系客服',
				})
				.then(() => {});
			},
			async initData(){
				console.log('mer_id---',this.mer_id)
				//用户信息
				const resUser = await userInfo()
				if(resUser.code == 1000){
					this.userinfo = resUser.data
					this.membership = resUser.data.membership //用户等级
					console.log('用户信息---',this.userinfo)
				}
				//轮播图信息
        		const res = await getAdvertising({ type: 0,mer_id:this.mer_id })
				if(res.code == 1000){
					this.swipeList = res.data
				}else {
					 this.$toast(res.msg)
				}
        		if(!localStorage.getItem('img')){
          			const res1 = await getAdvertising({ type: 2,mer_id:this.mer_id })
					if(res1.code == 1000){
						if(res1.data && res1.data[0]){
              				this.img = res1.data[0].advertising_image
					  		this.advertising_link = res1.data[0].advertising_link
							localStorage.setItem('img', 1)
							this.showpup = true
						}
					}else {
						this.$toast(res1.msg)
					}
				} else {
					this.showpup = false
				}
				
			},
			getZy(){
				if(this.iid){
					this.$router.push({path:'/information',query: {data: this.moredata} })
				} else {
					this.$toast('暂无数据')
				}
			},
			async initIndexData(){
        		const infores = await indexMemberStatistic()
				if(infores.code == 1000){
          			this.data = infores.data
					const arr = this.data.day.toString().split('')
					if(arr.length == 2){
						this.day3 = arr[1]
						this.day2 = arr[0]
					} else if(arr.length == 3){
						this.day3 = arr[2]
						this.day2 = arr[1]
						this.day1 = arr[0]
					} else if(arr.length == 1){
            			this.day3 = arr[0]
					}

          			console.log(this.day1, this.day2,this.day3)
					this.$store.commit('setDay1', this.day1)
					this.$store.commit('setDay2', this.day2)
					this.$store.commit('setDay3', this.day3)
					this.getpower(this.data.power)
				} else {
					this.$toast(infores.msg)
				}
			},

			async initFormatData(){
        const classRes = await informationType()
				if(classRes.code == 1000){
					const iid = classRes.data[0] && classRes.data[0].id? classRes.data[0].id : ''
					this.moredata = JSON.stringify(classRes.data)
					console.log(this.moredata)
					this.iid = iid
					if(classRes.data.length > 0){
						
						const r = await informationList({ iid, page: 1  })

						if(r.code == 1000){
							if(r.data.data.length > 2){
								this.list = r.data.data.splice(0, 2)
							} else {
								this.list = r.data.data
							}
						}else {
						this.$toast(r.msg)
						}
				  }
          
				}else {
					 this.$toast(classRes.msg)
				}
			},
			getpower(power){
				
				this.optionList.forEach((item, index) => {
					item.power = power[index]
				})
				
			},
			navs() {
				// this.$router.push({name: "/a"});	
			},

			// 用户在线日志
			async getUserLog(){
        const day = formatTime(new Date().getTime(), 5)
				const time = localStorage.getItem('timeindex')
				if(!time ||  time != day){
          const res = await userLoginLog()
					if( res.code != 1000 ){
						localStorage.setItem('timeindex', '')
					}
				}
			},

			// 首页选项跳转
			jumpOption(url, power){
				getCode().then(()=>{
					this.getJump(url, power)
				}).catch(()=>{})
			},
			async getJump(url, power){
				console.log('ccpower',power)
				if(url == '/historyquset' || url == '/imitatequest') power = 1 //历年真题 模拟考试都可以进入
				if(power){
					if(url == '/wordbook'){
						const res = await getEnglishBookPlan()
			
						if(res.data.select_book_status == 1){
							this.$router.push('/switchplan')
						
						} else {
								
							this.$router.push(url)
						}
						
					} else {
						if(this.userinfo.dqtime<Date.now()){
							if(url == '/historyquset' || url == '/imitatequest'){
							}else{
								this.$toast('您的会员已到期')
								return								
							}
						}							
						this.$router.push(url)	
					}
				} else {
					this.$toast('未有权限，请前往购买会员')
					setTimeout(()=>{
						//this.$router.replace('/index')
						this.$router.push({ path:'/vip',query:{ type: this.membership } })
					}, 800)
				}
			},
			
			clickJump(){
				getCode().then(()=>{
          		if(this.advertising_link){
					window.location.href = this.advertising_link
				}
				}).catch(()=>{})
			},
			chahao(){
				this.showpup = false
			},
			goService(){
				this.showService = true
			},

		}
	};
</script>
<style lang="less" scoped>
@import '@/assets/css/home.less';
.beian{
	text-align: center;
	margin-top: 30px;
	color: #999;
}
.pup_con {
	position: fixed;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	background-color: rgba(0,0,0,.5);
	z-index: 100;
}

.pup_img_con {
	max-width: 335px;
	max-height: 436px;
	position: absolute;
	left: 50%;
	top: 45%;
	transform: translate(-50%, -50%);

	.cha {
		position: absolute;
		bottom: -40px;
		left: 50%;
		transform: translateX(-50%);
	}

	.pup_img {
		border-radius: 10px;
		max-width: 335px;
	  max-height: 436px;
	}
}
/deep/.swiper_view {
	background-color: #fff !important;
	border-radius: 6px;
	box-shadow: 0px 6px 6px 0px rgba(73, 124, 255, 0.12);
}
.service{
	position: fixed;
	right: 20px;
	bottom: 100px;
	z-index: 999999;
	.service_img{
		width: 30px;
		height:30px;

	}
}
.home_option .every_option{
	z-index: 1;
}
.icon {
		position: absolute;
		left: 50%;
		bottom: -35px;
		transform: translateX(-50%);
		color: #fff;
		z-index: 20;
		font-size: 20px;
	}
</style>
